// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"condition_wrapper__2RVSd"};